if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"dashboard","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return true},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}